import React, { useState, useEffect } from 'react'
import { makeStyles, Button, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, InputLabel, MenuItem, Select, FormControl } from '@material-ui/core'
import { useAuthContext } from 'hooks/useAuthContext'
import { Issues, getIssueStatus, addIssueComment, addNewChildIssue } from 'utils/IssuesUtil'
import { Card, CardContent } from '@material-ui/core';
import Grid from './DtGrid'
import Typography from '@material-ui/core/Typography';
import AuthCheck from 'components/Shared/AuthCheck';


const useStyles = makeStyles((theme) => ({
    cardHeader: {
        "background": theme.palette.primary.main,
        "color": theme.palette.primary.contrastText
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
}))

const IssueGrid = ({ issue, reload }) => {

    const { userName } = useAuthContext()
    const dt = new Date()
    const [pendingState, setPendingState] = useState({ commentState: false, receivedState: false, commentDate: dt.getUTCFullYear() + "-" + ('0' + (dt.getMonth() + 1)).slice(-2) + "-" + ('0' + dt.getDate()).slice(-2) + "T" + ('0' + dt.getHours()).slice(-2) + ":" + ('0' + dt.getMinutes()).slice(-2), receiveComment: "", issueComment: "", updateDate: new Date(), open: false, openComment: false, data: null, receiveDate: dt.getUTCFullYear() + "-" + ('0' + (dt.getMonth() + 1)).slice(-2) + "-" + ('0' + dt.getDate()).slice(-2) + "T" + ('0' + dt.getHours()).slice(-2) + ":" + ('0' + dt.getMinutes()).slice(-2) })
    const [statusIssueDesc, setStatusIssueDesc] = React.useState('')
    const [showResolved, setShowResolved] = useState(false)
    const [statusIssue, setStatusIssue] = React.useState(issue.IssueProcStatusId_IssueProcStatus)
    const [issueDescription, setIssueDescription] = React.useState(issue.Description_IssueProcStatus)
    const [options, setOptions] = React.useState([])
    const [displayerror, setDisplayerror] = React.useState(false)

    const handleChange = (event, value) => {
        setStatusIssue(value.props.value)
        setStatusIssueDesc(value.props.children[0])
        if (value.props.children[0].search("Resolved") !== -1 || value.props.children[0].search("Close") !== -1)
            setShowResolved(true)
        else
            setShowResolved(false)
    }

    useEffect(() => {
        let mounted = true;
        if (options.length === 0) {
            getIssueStatus().then(data => {
                mounted && setOptions(data)
            })
        }
        return () => mounted = false;
    })

    const handleAddComment = () => {
        const data = []
        if (pendingState.issueComment.trim().length > 0) {
            data.push({
                IssueId: issue.IssueId,
                Comment: pendingState.issueComment,
                CommentDate: pendingState.commentDate,
                MadeBy: userName
            })
            addIssueComment(data, issue.IssueId).then(data => {
                reload(new Date())
            })
            handleClose()
        } else {
            setDisplayerror(true)
        }
    }
    const handleClose = () => {
        setPendingState({
            ...pendingState,
            open: false,
            openComment: false,
        })
        setStatusIssue(issue.IssueProcStatusId_IssueProcStatus)
        if (issue.Description_IssueProcStatus.search("Resolved") !== -1 || issue.Description_IssueProcStatus.search("Close") !== -1)
            setShowResolved(true)
        else
            setShowResolved(false)
    }
    const receiveSample = (data) => {
        setPendingState({
            ...pendingState,
            data: data,
            open: true,
        })
    }
    const receiveComment = (data) => {
        setPendingState({
            ...pendingState,
            data: data,
            openComment: true,
        })
    }
    const handleCreateIssue = () => {
        issue.MadeBy = userName
        issue.OpenDate = new Date().toISOString();
        addNewChildIssue(issue, issue.IssueId, statusIssueDesc, statusIssue, pendingState.receiveDate, pendingState.receiveComment, issueDescription).then(res => {
            reload(new Date())
        })
    };

    const classes = useStyles()
    const search = { "display": false }


    return (
        <div>
            <div>
                {
                    issue.children.length === 0 ? <div>
                        <AuthCheck scope="Issues" action="update">
                            <Button onClick={receiveSample} color="primary">Edit</Button>
                            <Button onClick={receiveComment} color="primary"> Add Comment </Button>
                        </AuthCheck>
                    </div> : <div></div>}

                <Dialog open={pendingState.open} onClose={handleClose} disableBackdropClick >
                    <DialogTitle id="form-dialog-title" className={classes.cardHeader}>Update Issue Status</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            User:  {userName}
                        </DialogContentText>
                        <FormControl className={classes.formControl}>
                            <InputLabel id="status-select-label">Status</InputLabel>
                            <Select
                                labelId="status-select-label"
                                id="status_select"
                                value={statusIssue}
                                onChange={handleChange}
                            >
                                {options.data && options.data.map((item, keyIndex) =>
                                    <MenuItem key={item.domainId} value={item.domainId}>{item.description} </MenuItem>
                                )}

                            </Select> <br />
                            <TextField id="issue_description" label="Description" value={issueDescription} onChange={e => setIssueDescription(e.target.value)} /> <br />
                        </FormControl> <br />
                        {showResolved ? <div>
                            <TextField
                                id="resolved_date"
                                label="Resolved Date"
                                type="datetime-local"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                defaultValue={pendingState.receiveDate}
                                onChange={e => setPendingState({
                                    ...pendingState,
                                    receiveDate: e.target.value,
                                })}
                            /><br />
                            <TextField id="receive_comment" label="Resolved Description" value={pendingState.receiveComment} onChange={e => setPendingState({
                                ...pendingState,
                                receiveComment: e.target.value,
                            })} /><br />
                        </div> : null}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="primary">
                            Cancel
              </Button>
                        <Button color="primary" onClick={handleCreateIssue}>
                            Update Status
             </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={pendingState.openComment} onClose={handleClose} disableBackdropClick >
                    <DialogTitle id="form-dialog-title" className={classes.cardHeader}>Add Comments</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            User:  {userName}
                        </DialogContentText>
                        <TextField
                            id="comment_date"
                            disabled
                            label="Comment Date"
                            type="datetime-local"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            defaultValue={pendingState.commentDate}
                            onChange={e => setPendingState({
                                ...pendingState,
                                commentDate: e.target.value,
                            })}
                        /><br />
                        <TextField id="issue_comment" label="Issue Comment" value={pendingState.issueComment} onChange={e => setPendingState({
                            ...pendingState,
                            issueComment: e.target.value,
                        })} /><br />
                        {displayerror ? <Typography color='error' variant='body1'>Comment cannot be empty</Typography> : null}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="primary">
                            Cancel
            </Button>
                        <Button onClick={handleAddComment} color="primary">
                            Add Comment
           </Button>
                    </DialogActions>
                </Dialog>
            </div>
            <Card>
                <CardContent>
                    <Grid columns={Issues.columns} title={"Issue"} data={[issue]} component="Issues" showEditIcon={false} selection={search} paging={false} />
                </CardContent>
            </Card>
        </div>
    )

}

export default IssueGrid
